module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"emptyText":"No data exported"},"it":{"emptyText":"Nessun dato esportato"}}')
  delete Component.options._Ctor
}
